import React, { useMemo } from "react";
import { Tooltip } from "@blueprintjs/core";
import { useSelector } from "react-redux";
import classNames from "classnames";
import TextTruncate from "components/TextTruncate";
import LineTypeIndicator from "../LineTypeIndicator";
import { ResultElementSourceType, } from "store/rs-workspace/rs-workspace.types";
import { processDataViewerSourceFormValuesSelector } from "store/rs-workspace/selectors/results.selectors";
import { getSourceLineColor } from "store/rs-workspace/utils/results.utils";
import * as styles from "./styles.module.scss";
export var ProcessDataViewerGraphTestIds;
(function (ProcessDataViewerGraphTestIds) {
    ProcessDataViewerGraphTestIds["sourceVariable"] = "sourceVariable";
})(ProcessDataViewerGraphTestIds || (ProcessDataViewerGraphTestIds = {}));
const SourceVariable = ({ source, index, colorIndex, className }) => {
    const { preparedSource } = useSelector(processDataViewerSourceFormValuesSelector(source ?? {}));
    const title = useMemo(() => {
        const variable = preparedSource?.source?._variableName?.label;
        const units = preparedSource?.source?.units?.label;
        return preparedSource?.source?.type === ResultElementSourceType.Insight
            ? preparedSource?.source?._sourceName
            : `${variable} ${units ? `(${units})` : ""}`;
    }, [
        preparedSource?.source?._sourceName,
        preparedSource?.source?._variableName?.label,
        preparedSource?.source?.type,
        preparedSource?.source?.units?.label,
    ]);
    return !source ? null : (React.createElement(Tooltip, { key: `${source?.id}-${index}`, content: preparedSource?.source?._sourceName, minimal: true, openOnTargetFocus: false, placement: "bottom-end", popoverClassName: styles.tooltip, targetTagName: "div", className: classNames(styles["variable-container"], className) },
        React.createElement("div", { className: styles.variable, "data-testid": ProcessDataViewerGraphTestIds.sourceVariable },
            React.createElement(LineTypeIndicator, { className: styles.indicator, color: getSourceLineColor(preparedSource?.color, colorIndex) }),
            React.createElement(TextTruncate, { className: styles.name, text: title }))));
};
export default SourceVariable;
